<template>
  <!-- 兑换记录 -->
  <div class="forRecord" style="padding: 0.53rem 0.15rem 0.11rem 0.15rem">
    <van-list v-model="loading" :finished="finished" @load="onLoad">
      <div class="forRecord_shop" v-for="shop in ForRecordList" :key="shop.id">
        <h2 style="font-size: 0.12rem; color: #ff5d5d; line-height: 0.2rem">
          <span v-show="shop.state == 1">待发货</span>
          <span v-show="shop.state == 2">已完成</span>
        </h2>
        <div class="forRecord_content">
          <img
            :src="shop.shop_pic"
            alt=""
            style="
              width: 0.88rem;
              height: 0.88rem;
              background: #fafafa;
              margin-right: 0.15rem;
            "
          />
          <div class="forRecord_content_right">
            <h3
              style="
                font-size: 0.14rem;
                color: #333333;
                line-height: 0.2rem;
                margin-bottom: 0.24rem;
              "
            >
              {{ shop.title ? shop.title : "--" }}
            </h3>
            <p
              style="
                font-size: 0.12rem;
                color: #999a9c;
                line-height: 0.2rem;
                margin-bottom: 0.06rem;
              "
            >
              兑换时间：{{ shop.ctime ? shop.ctime : "--" }}
            </p>
            <div
              class="cord"
              style="font-size: 0.12rem; color: #999a9c; line-height: 0.2rem"
            >
              <p>
                兑换积分：
                <span
                  style="
                    font-size: 0.14rem;
                    font-weight: bold;
                    color: #f12727;
                    line-height: 0.2rem;
                  "
                  >{{ shop.price ? shop.price : "-" }}</span
                >
              </p>
              <p>x{{ shop.num ? shop.num : "-" }}</p>
            </div>
          </div>
        </div>
        <div class="btn">
          <van-button class="logistics" @click="toLogistics(shop.kuaidi)"
            >查看物流</van-button
          >
        </div>
      </div>
      <!-- 底部的tab切换 -->
      <div class="tabbar">
        <van-tabbar
          v-model="active"
          inactive-color="#333333"
          active-color="#93683D"
        >
          <van-tabbar-item to="/welfare">
            <span>积分商城</span>
            <template #icon="props">
              <img :src="props.active ? icon.active1 : icon.inactive1" />
            </template>
          </van-tabbar-item>
          <van-tabbar-item to="/forRecord">
            <span>兑换记录</span>
            <template #icon="props">
              <img :src="props.active ? icon.active2 : icon.inactive2" />
            </template>
          </van-tabbar-item>
          <van-tabbar-item to="/integralWater">
            <span>积分流水</span>
            <template #icon="props">
              <img :src="props.active ? icon.active3 : icon.inactive3" />
            </template>
          </van-tabbar-item>
        </van-tabbar>
      </div>
    </van-list>
    <!-- 当没有兑换记录时 -->
    <div
      v-if="isNone"
      class="noOrder"
      style="
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f3f1f4;
      "
    >
      <img
        src="../../assets/img/empty/img_blank_exchange@2x.png"
        alt=""
        style="width: 2.17rem; height: 1.75rem; margin-top: 1.16rem"
      />
      <div
        class="noOrder_content"
        style="display: flex; flex-direction: column; align-items: center"
      >
        <p
          style="
            height: 0.24rem;
            font-size: 0.12rem;
            color: #99999b;
            line-height: 0.24rem;
          "
        >
          还没有兑换记录哦，
        </p>
        <p
          style="
            height: 0.24rem;
            font-size: 0.12rem;
            color: #99999b;
            line-height: 0.24rem;
          "
        >
          去看看可以兑换的商品吧~
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getForRecordList } from '../../api/home'
export default {
  data () {
    return {
      ForRecordList: [],
      loading: false,
      finished: false,
      page: 1,
      isNone: false,
      active: 1,
      icon: {
        active1: require('../../assets/img/welfare/mall_btn_home_pre@2x.png'),
        inactive1: require('../../assets/img/welfare/mall_btn_home@2x.png'),
        active2: require('../../assets/img/welfare/mall_btn_record_pre@2x.png'),
        inactive2: require('../../assets/img/welfare/mall_btn_record@2x.png'),
        active3: require('../../assets/img/welfare/mall_btn_bill_pre@2x.png'),
        inactive3: require('../../assets/img/welfare/mall_btn_bill@2x.png')
      }
    }
  },
  created () {
    this.onLoad()
  },
  methods: {
    onLoad (val) {
      this.loading = true
      getForRecordList({ page: this.page })
        .then((res) => {
          this.page += 1
          this.ForRecordList.push(...res.data.backdata.lists)
          if (res.data.backdata.lists == 0) {
            this.isNone = true
          } else {
            this.isNone = false
          }
          if (this.ForRecordList.length >= res.data.ext.total) {
            this.finished = true
          }
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
    toLogistics (kuaidi) {
      // console.log(kuaidi);
      window.location.href =
        'https://m.kuaidi100.com/app/query/?coname=weilairunmei&nu=' + kuaidi
    }
  }
}
</script>

<style lang='scss'>
.forRecord {
  .tabbar {
    height: 0.49rem;
    .van-tabbar {
      height: 0.49rem;
      .van-tabbar-item {
        img {
          width: 0.22rem;
          height: 0.22rem;
        }
        span {
          display: block;
          transform: scale(0.8);
          font-size: 0.125rem;
        }
      }
    }
  }
  .forRecord_shop {
    width: 100%;
    height: 1.98rem;
    background: #ffffff;
    border-radius: 0.02rem;
    margin-top: 0.11rem;
    padding: 0.11rem 0.15rem 0.2rem 0.15rem;
    h2 {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 0.11rem;
    }
    .forRecord_content {
      display: flex;
      align-items: flex-start;
      .forRecord_content_right {
        width: 100%;
        .cord {
          width: 100%;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .btn {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      .logistics {
        width: 0.93rem;
        height: 0.3rem;
        background: #ffffff;
        border: 1px solid #bdbdbd;
        border-radius: 0.15rem;
        font-size: 0.14rem;
        color: #333333;
        margin-top: 0.2rem;
      }
    }
  }
}
</style>
